<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('send_pagements.payment_details')" :close-on-click-modal="false" width="739px">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('send_pagements.single_payment_details') }}
      </div>
      <div class="section-tip">
        {{ $t('tips.select_receiving_channel_and_fill_payments_details') }}
      </div>
      <div class="form-container">
        <el-form ref="singleDisbursementForm" :model="singleDisbursementForm" status-icon label-position="top">

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('merchantAccount.recipient_channel')"
                prop="code"
              >
                <el-select v-model="singleDisbursementForm.full_name" filterable class="select-item" clearable disabled>
                  <el-option
                    v-for="(item,index) in bankList"
                    :key="index"
                    :label="item.name_with_full_bank"
                    :value="item.bank_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">

              <el-form-item
                :label="$t('send_pagements.recipient_account_number')"
                prop="account_no"
              >
                <el-input
                  v-model.trim="singleDisbursementForm.account_no"
                  class="search-frame"
                  autocomplete="off"
                  maxlength="30"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('merchantAccount.recipient_name')"
                prop="account_name"
              >
                <el-input
                  v-model="singleDisbursementForm.account_name"
                  class="search-frame"
                  autocomplete="off"
                  maxlength="60"
                  clearable
                  disabled
                  @blur="singleDisbursementForm.account_name=$event.target.value.trim()"
                />
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">

              <el-form-item
                :label="$t('components.amount')"
                prop="amount"
              >
                <el-input v-model="singleDisbursementForm.amount" :controls="false" class="custom-input-number" autocomplete="off" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('customerService.email_address')"
                prop="email"
              >
                <el-input v-model.trim="singleDisbursementForm.email" class="search-frame" autocomplete="off" clearable disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">

              <el-form-item :label="$t('data.remark')">
                <el-input
                  v-model="singleDisbursementForm.remark"
                  type="textarea"
                  autocomplete="off"
                  maxlength="255"
                  disabled
                  @blur="singleDisbursementForm.remark=$event.target.value.trim()"
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn">Submit</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'Needs_Approval_Detail',
  data() {
    return {
      bankList: [],
      singleDisbursementForm: { },
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false
    }
  },
  methods: {
    // 改变弹框状态
    changModalStatus(config) {
      this.dialogVisible = config.status
      this.singleDisbursementForm = config.value
    }
  }
}
</script>

<style scoped>
.select-item{
  width: 100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 500px;
  height: 40px;
  border-radius: 4px;
}
</style>
